import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Box } from '@material-ui/core';
import BlockIcon from '@material-ui/icons/Block';
import styles from './ReprintWarningDialog.module.css';

const ReprintWarningDialog = ({ onConfirm, onCancel, open }) => {
    return (
        <Modal open={open} onClose={onCancel}>
            <div className={styles.container} data-testid="confirmation-popup">
                <div className={styles.title}>
                    <span>
                        <BlockIcon className={styles.block} />
                    </span>
                    <span className={styles.txt}>Warning</span>
                </div>
                <Box bgcolor="#dadada3d" marginTop="33px" height="130px">
                    <p className={styles.warningText}>
                        This ASN is already dropped. Are you sure you want to take a reprint of the ASN?
                    </p>
                </Box>
                <div className={styles.bottomRow}>
                    <button className={styles.cancelBt} onClick={onCancel}>
                        Cancel
                    </button>
                    <span>
                        <button
                            onClick={() => {
                                onCancel();
                                onConfirm();
                            }}
                            className={styles.submitBt}
                        >
                            Confirm
                        </button>
                    </span>
                </div>
            </div>
        </Modal>
    );
};

ReprintWarningDialog.propTypes = {
    onConfirm: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
};

export default ReprintWarningDialog;
